import type {
  IGoodsListPageInitialData,
  IProductListApiParams,
  IProductListApiResponse,
  IProductListItem,
} from '@/api/types/product';
import { createGoodsListClientGroup } from '../components/goodsListSeoFooter.utils';

/** 仅裁剪列表项根级分组；保留关联商品和广告跳转配置中的同名字段。 */
export function toGoodsListItemsDto<T extends IProductListItem & { product_group?: unknown }>(
  list: T[],
): Omit<T, 'product_group'>[] {
  return list.map(({ product_group: _productGroup, ...item }) => item);
}

/** 只从响应 params 提取请求级推荐结果类型，不下发整份 params。 */
export function toGoodsListInitialData(
  data: IProductListApiResponse & {
    params?: IProductListApiParams & { recommend_result_type?: string };
  },
  page: number,
  limit: number,
): IGoodsListPageInitialData {
  const { group, list, total, all_total, image_rule, hover_image_rule } = data;

  return {
    group: createGoodsListClientGroup({
      ...group,
      ...(data.params?.recommend_result_type === undefined
        ? {}
        : { recommend_result_type: data.params.recommend_result_type }),
    }),
    list: toGoodsListItemsDto(list),
    total,
    all_total,
    image_rule,
    hover_image_rule,
    noData: list.length === 0,
    noMoreShow: all_total <= page * limit,
  };
}
